// src/pages/Reports/CurrentAssetBalance/components/exportCurrentAssetBalanceCsv.js
import dayjs from "dayjs";
import _ from "lodash";

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

const fmtNum  = (val) => Number(val || 0).toFixed(2);
const fmtDate = (val) => (val ? dayjs(val).format("DD-MMM-YYYY") : "-");

/**
 * @param {object} params
 * @param {Array}  params.list          - from Redux state.currentAssetBalance.list
 * @param {number} params.total_balance - from Redux state.currentAssetBalance.total_balance
 * @param {object} params.filters       - { type, accId, fromDate, toDate }
 * @param {string} params.title
 * @param {string} params.filename
 */
export const exportCurrentAssetBalanceCsv = ({
  list,
  total_balance,
  filters,
  title    = "Current Asset Balance Report",
  filename = "current_asset_balance_report",
}) => {
  const rows = [[title]];

  if (filters.type === "Date Wise") {
    rows.push([`From: ${fmtDate(filters.fromDate)}  To: ${fmtDate(filters.toDate)}`]);
  } else {
    rows.push([`Filter: ${filters.type}`]);
  }

  rows.push([]);

  const headers = [
    "No.", "Account Name",
    "Opening Balance", "Debit Amount",
    "Credit Amount", "Balance",
  ].map(escape);

  rows.push(headers);

  list.forEach((row, i) => {
    rows.push([
      i + 1,
      row.acc_name        || "",
      fmtNum(row.opening_balance),
      fmtNum(row.received_total),
      fmtNum(row.pay_total),
      fmtNum(row.balance),
    ].map(escape));
  });

  // Grand total — mirrors the table summary exactly
  rows.push([]);
  rows.push([
    "Grand Total", "",
    fmtNum(_.sumBy(list, (r) => Number(r.opening_balance))),
    fmtNum(_.sumBy(list, (r) => Number(r.received_total))),
    fmtNum(_.sumBy(list, (r) => Number(r.pay_total))),
    fmtNum(total_balance),
  ].map(escape));

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};